import React, {Component} from 'react'
import { Route, Link } from "react-router-dom";
import Parse from 'parse';
import TransitionGroup from "react-transition-group/TransitionGroup";
import AnimatedSwitch from "./utils/animated_switch";
import Header from "./components/header";
import Footer from "./components/footer";
import Home from "./pages/home";
import Contact from "./pages/contact";
import Services from "./pages/services";
import Portfolio from "./pages/portfolio";
import Testimonials from "./pages/testimonials";
import Products from "./pages/products";

export class Layout extends Component {
  constructor(props) {
      super(props);
      this.state = ({

			})
  }
  componentDidMount = () =>{
    document.getElementsByTagName("main")[0].scrollTop = 0;
  }
  render() {
    return(
      <div>
        { this.props.children }
        <Footer />
      </div>
    )
  }
}

export default class App extends Component {
  constructor() {
      super();
			this.state = {}
  }
  componentDidMount = () =>{

  }

  render() {
   return (
	<Route
		render={({ location }) => (
      <div>
        <Header/>
        <TransitionGroup component="main">
          <AnimatedSwitch key={location.key} location={location}>
            <Route exact path="/" render={props => (<Layout><Home /></Layout>)} />
            <Route exact path="/portfolio" render={props => (<Layout><Portfolio /></Layout>)} />
            <Route exact path="/services" render={props => (<Layout><Services /></Layout>)} />
            <Route exact path="/products" render={props => (<Layout><Products /></Layout>)} />
            <Route exact path="/testimonials" render={props => (<Layout><Testimonials /></Layout>)} />
            <Route exact path="/contact" render={props => (<Layout><Contact /></Layout>)} />
          </AnimatedSwitch>
        </TransitionGroup>
        
        {/* Sticky Footer Banner - Appears on all pages */}
        <div className="primary-background sticky-footer-desktop" style={{
          position: "fixed",
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 1000,
          padding: "25px 30px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          boxShadow: "0 -2px 10px rgba(0,0,0,0.1)",
          flexDirection: "row"
        }}>
          <div className="white" style={{
            fontSize: "28px", 
            fontWeight: "300", 
            textAlign: "right", 
            flex: 1
          }}>
            Get a free estimate today
          </div>
          <Link to="/contact">
            <div className="button accent-background white" style={{
              backgroundColor: "#FF5722",
              color: "#fff",
              padding: "15px 60px",
              fontSize: "16px",
              fontWeight: "bold",
              borderRadius: "4px",
              textDecoration: "none",
              marginLeft: "20px"
            }}>
              Contact Us
            </div>
          </Link>
        </div>
        
        {/* Mobile Sticky Footer Banner */}
        <div className="primary-background sticky-footer-mobile" style={{
          position: "fixed",
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 1000,
          padding: "20px 15px",
          display: "none",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          boxShadow: "0 -2px 10px rgba(0,0,0,0.1)",
          textAlign: "center"
        }}>
          <div className="white" style={{
            fontSize: "18px", 
            fontWeight: "300", 
            marginBottom: "15px",
            textAlign: "center"
          }}>
            Get a free estimate today
          </div>
          <Link to="/contact">
            <div className="button accent-background white" style={{
              backgroundColor: "#FF5722",
              color: "#fff",
              padding: "12px 40px",
              fontSize: "14px",
              fontWeight: "bold",
              borderRadius: "4px",
              textDecoration: "none",
              textAlign: "center"
            }}>
              Contact Us
            </div>
          </Link>
        </div>

        {/* CSS for Responsive Sticky Footer */}
        <style jsx>{`
          @media (max-width: 768px) {
            .sticky-footer-desktop {
              display: none !important;
            }
            .sticky-footer-mobile {
              display: flex !important;
            }
          }
          @media (min-width: 769px) {
            .sticky-footer-desktop {
              display: flex !important;
            }
            .sticky-footer-mobile {
              display: none !important;
            }
          }
        `}</style>
      </div>
		)}
 />
	 );
  }
}



// WEBPACK FOOTER //
// ./src/app.js